import React, { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import './styles.css';

import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {
    Autocomplete, Box, Card, CardContent, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
    Input, InputAdornment, IconButton, Button, CircularProgress, TextField, Select, MenuItem, Typography
} from "@mui/material";
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from 'recharts';

import { Drawer } from '../Drawer';
import { UsageTable } from '../UsageTable';
import { getUserOrganisation, getOrganisationMembers, createOrganisation, removeOrganisationMember, updateUserRole, inviteMembers, getOrganisationUsage } from '../../services/organisation.service';
import clsx from 'clsx';

export const StackedBarChart = ({data, measureType}) => {

    return (
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        {measureType == 'metric' ? (
            <>
                <Bar dataKey="frames" stackId="a" fill="#8884d8" />
                <Bar dataKey="seconds" stackId="a" fill="#82ca9d" />
                <Bar dataKey="images" stackId="a" fill="#ffc658" />
                <Bar dataKey="chars" stackId="a" fill="#FF8042" />
            </>
        ) : (
            <>
                <Bar dataKey="video" stackId="a" fill="#8884d8" />
                <Bar dataKey="audio" stackId="a" fill="#82ca9d" />
                <Bar dataKey="image" stackId="a" fill="#ffc658" />
                <Bar dataKey="text" stackId="a" fill="#FF8042" />
            </>
        )}
        
      </BarChart>
    );
  }

const RoleTag = (role, acceptedInvitation) => {
    if (!acceptedInvitation) {
        return (
            <div className="tagContainer invitedContainer">
                Invited
            </div>
        )
    }

    switch (role) {
        case "OWNER":
            return (
                <div className="tagContainer adminContainer">
                    Admin
                </div>
            )
        case "MEMBER":
            return (
                <div className="tagContainer memberContainer">
                    Member
                </div>
            )
        default:
            return null
    }
}

const UserRoleSelector = ({ userRole, setUserRole, isFullWidth = true, className="" }) => {
    return (
        <Select
            autoFocus
            margin="dense"
            fullWidth={isFullWidth}
            value={userRole}
            label="User role"
            placeholder="Select user role"
            onChange={(event) => setUserRole(event.target.value)}
            className={className}
        >
            <MenuItem value={"OWNER"}>Administrator</MenuItem>
            <MenuItem value={"MEMBER"}>Member</MenuItem>
        </Select>
    )
}

const AutocompleteWithTags = ({ value, setValue, inputValue, setInputValue, popup }) => {
    const [currentEmailValue, setCurrentEmailValue] = useState("");
    const [currentRoleValue, setCurrentRoleValue] = useState("MEMBER");

    const addMemberAndResetInputs = () => {
        setValue(currentValue => [...currentValue, { "email": currentEmailValue, "role": currentRoleValue }]);
        setCurrentEmailValue("");
        setCurrentRoleValue("MEMBER");
    }

    const removeMemberFromInvited = (removedMember) => {
        setValue(currentValue => [...currentValue.filter(member => member != removedMember)])
    }

    return (
        <>
            <div className='inviteMembersHeadersContainer'>
                <p className={clsx('inviteMembersHeader', popup == true && 'inviteMembersHeaderBig')}>
                    Write members email
                </p>
                <p className={clsx('inviteMembersHeader', popup == true && 'inviteMembersHeaderBig')}>
                    Select members role
                </p>
            </div>
            <Box className='inviteMembersInputsContainer'>
                <Input className={clsx('inviteMembersInput', popup == true && 'inviteMembersInputBig')} placeholder="Input members email" value={currentEmailValue} onChange={(event) => setCurrentEmailValue(event.target.value)} />
                <UserRoleSelector className={clsx('inviteMembersInput', popup == true && 'inviteMembersInputBig')} userRole={currentRoleValue} setUserRole={setCurrentRoleValue} isFullWidth={false} />
                <Button className='inviteMembersInput' onClick={addMemberAndResetInputs} sx={{width: popup ? '20%' : '10%', color: '#dddddd'}}>Invite</Button>
            </Box>
            <p>
                Invited members
            </p>
            <div className="invitedMembersContainer">
                {value.map((member) => (
                    <div class="invitedMember">
                        <p className={clsx('invitedMemberInfo', popup == true && 'invitedMemberInfoBig')}>
                            {member.email}
                        </p>
                        <p className={clsx('invitedMemberInfo', popup == true && 'invitedMemberInfoBig')}>
                            {member.role}
                        </p>
                        <IconButton sx={{ color: "red", width: "10%", display: "flex", justifyContent: "center"}} onClick={() => removeMemberFromInvited(member)}>
                            <DeleteIcon />
                        </IconButton>
                    </div>
                ))}
            </div>
        </>
    )
    return (
        <Autocomplete
            value={value}
            options={[]}
            freeSolo
            multiple
            fullWidth={true}
            inputValue={inputValue}
            renderTags={(value, props) =>
                value.map((option, index) => (
                    <Chip {...props({ index })} label={option} onDelete={() => setValue(members => members.filter(row => row != option))} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    label="Invite members"
                    placeholder="Insert emails of people you want to invite"
                    onChange={(event) => {
                        const lastCharacter = event.target.value.slice(-1)
                        if (lastCharacter === ' ' || lastCharacter === ',' || lastCharacter === 'Enter') {
                            return;
                        }
                        setInputValue(event.target.value)
                    }}
                    onKeyDown={e => {
                        if ((e.key === "Enter" || e.key === ' ' || e.key === ',')) {
                            setInputValue("");
                            setValue(members => [...members, e.target.value]);
                        }
                    }}
                />
            )}
        />
    )
}

const EditRole = ({ open, handleClose, role, updateRole }) => {
    const [userRole, setUserRole] = useState(role);

    const updateRoleAndClose = () => {
        updateRole(userRole);
        handleClose();
    }

    useEffect(() => {
        setUserRole(role);
    }, [role])

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Change user role</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    To allow other people to manage your organization, give them an ADMIN role.
                </DialogContentText>
                <UserRoleSelector userRole={userRole} setUserRole={setUserRole} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={updateRoleAndClose}>Update</Button>
            </DialogActions>
        </Dialog>
    )
}

const AddMember = ({ open, handleClose, invitedMembers, setInvitedMembers, invitedMembersTextField, setInvitedMembersTextField, inviteMembers }) => {

    const inviteMembersAndClose = () => {
        inviteMembers();
        handleClose();
    }

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Add new members</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Invite new members to join your organisation.
                </DialogContentText>

                <AutocompleteWithTags
                    value={invitedMembers}
                    setValue={setInvitedMembers}
                    inputValue={invitedMembersTextField}
                    setInputValue={setInvitedMembersTextField}
                    popup={true}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={inviteMembersAndClose}>Invite</Button>
            </DialogActions>
        </Dialog>
    )
}

export const Organisation = () => {
    const [isMember, setIsMember] = useState(null);
    const [memberPage, setMemberPage] = useState(0);
    const [totalMemberPages, setTotalMemberPages] = useState(0);
    const [totalMembers, setTotalMembers] = useState(0);
    const [currentUserData, setCurrentUserData] = useState({});
    const [memberData, setMemberData] = useState([]);
    const [organisationData, setOrganisationData] = useState(null);

    const [organisationUsage, setOrganisationUsage] = useState([]);
    const [measureType, setMeasureType] = useState("");

    const [isRoleEditModalOpen, setIsRoleEditModalOpen] = useState(null);
    const [isAddMemberModalOpen, setIsAddMemberModalOpen] = useState(false);

    const [invitedMembers, setInvitedMembers] = useState([]);
    const [organisationName, setOrganisationName] = useState("");
    const [invitedMembersTextField, setInvitedMembersTextField] = useState("");

    const [filterTextField, setFilterTextField] = useState("");

    const getAndSetOrganisation = async () => {
        const response = await getUserOrganisation();

        if ((response.status == 200 || response.status == 201)) {
            if (response.data) {
                setOrganisationData(response.data[0]);
                setIsMember(true);
            } else {
                setIsMember(false);
            }
        } else {
            toast.error('Getting organisation data failed!')
        }
    }

    const loadOrganisationUsage = async () => {
        const data = (await getOrganisationUsage()).data
        let raw = data.monthly_data;
        let measureType = data.measure_type;
        
        let usage = []
        for(const key of Object.keys(raw).sort()) {
            let element = raw[key]
            element['month'] = key
            usage.push(element)
        }
        
        setOrganisationUsage(usage)
        setMeasureType(measureType)
    }

    const removeAndSetOrganisationMember = async (organisationId, userId) => {
        const response = await removeOrganisationMember(organisationId, userId);

        if ((response.status == 200 || response.status == 201)) {
            setMemberData((members) => members.filter(row => row.user_id != userId));
        } else {
            toast.error('Getting organisation data failed!')
        }
    }

    const createAndSetOrganisation = async () => {
        const response = await createOrganisation(organisationName, invitedMembers);

        if ((response.status == 200 || response.status == 201)) {
            toast.success("Organisation created successfully!");
            
            setOrganisationData(response.data.organisation);
            setIsMember(true);
        } else {
            toast.error('Getting organisation data failed!');
        }
    }

    const getAndSetOrganisationMembers = async () => {
        const response = await getOrganisationMembers(organisationData.id, memberPage, filterTextField);

        if ((response.status == 200 || response.status == 201)) {
            setMemberData(response.data.members);
            setCurrentUserData(response.data.current_user);
            setTotalMemberPages(response.data.total_pages);
            setTotalMembers(response.data.total);
        } else {
            toast.error('Fetching organisation data failed!');
        }
    }

    const updateAndSetUserRole = async (userId, role) => {
        const response = await updateUserRole(organisationData.id, userId, role);

        if ((response.status == 200 || response.status == 201)) {
            setMemberData(members => [...members.filter(member => member.user_id != userId), {
                ...members.filter(
                    member => member.user_id == userId
                )[0],
                user_role: role
            }]);
        } else {
            toast.error('Fetching organisation data failed!');
        }
    }

    const inviteAndSetMembers = async () => {
        const response = await inviteMembers(invitedMembers);

        if ((response.status == 200 || response.status == 201)) {
            setMemberData(members => [...members, ...response.data.members]);
            setTotalMembers(totalMembers => totalMembers + invitedMembers.length);
        } else {
            toast.error('Fetching organisation data failed!');
        }
    }

    useEffect(() => {
        getAndSetOrganisation()
    }, []);

    useEffect(() => {
        if (isMember) {
            getAndSetOrganisationMembers();
            //loadOrganisationUsage();
        }
    }, [isMember, memberPage])

    useEffect(() => {
        if (filterTextField.length < 3) return;

        getAndSetOrganisationMembers();
    }, [filterTextField])

    if (isMember == null) {
        return (
            <Drawer>
                <CircularProgress />
            </Drawer>
        )
    }

    if (isMember == false) {
        return (
            <Drawer>
                <div className="h1_searchbar_container">
                    <p className="title">
                        Create an organization
                    </p>

                    <p className="subtitle">
                        Share uploaded videos effortlessly
                    </p>
                </div>

                <div className='inputContainer'>
                    <div>
                        <p>
                            Name of the organization
                        </p>

                        <Input value={organisationName} onChange={(event) => setOrganisationName(event.target.value)} placeholder={"Organization name"} />
                    </div>
                    <div>
                        <p>
                            Add members to your organization
                        </p>

                        <AutocompleteWithTags
                            value={invitedMembers}
                            setValue={setInvitedMembers}
                            inputValue={invitedMembersTextField}
                            setInputValue={setInvitedMembersTextField}
                        />
                    </div>
                </div>

                <div className='submitButton'>
                    <Button
                        sx={{
                            backgroundColor: "#7020ff",
                            color: "#ffffff",
                            borderRadius: "16px 0px 16px 0px",
                            padding: "0% 1%",
                            minWidth: "18vw",
                        }}
                        onClick={createAndSetOrganisation}
                    >
                        <p style={{
                            paddingLeft: "2%",
                            fontSize: "16px",
                            fontWeight: 600
                        }}>Create an organization</p>
                    </Button>
                </div>
            </Drawer>
        )
    }

    return (
        <Drawer>
            <div className="h1_searchbar_container">
                <div className="topbar-container">
                    <div className="text_container">
                        <div className="title">
                            Organization management
                        </div>

                        <div className="subtitle">
                            Here you can modify, remove or add more members to your organization
                        </div>
                    </div>

                    <Input
                        sx={{
                            marginBottom: "0%",
                            ".MuiInput-underline": {
                                background: "#CCCCCC"
                            },
                            "& .MuiInputBase-root.MuiInput-root:hover": {
                                borderBottomColor: "#CCCCCC"
                            },
                            "& .MuiInputBase-root.MuiInput-root:focused": {
                                borderBottomColor: "#E0E0E0"
                            },
                        }}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="search"
                                    edge="end"
                                >
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        }
                        onChange={(event) => setFilterTextField(event.target.value)}
                        fullWidth={true}
                        label="Find members by prefix"
                        placeholder="Find members by prefix"
                    />
                </div>
            </div>



            <div className="headerbox_container">
                <div className="Rectangle">
                    NAME
                </div>
                <div className="Rectangle">
                    USER ROLE
                </div>
                <div className="Rectangle">
                    OPTIONS
                </div>
            </div>

            <div className="preview_text_container">
                Showing {memberData.length} out of {totalMembers}
            </div>

            <div className="membersContainer">
                {
                    memberData.map(member => {
                        let currentUserRole = "";
                        if (isRoleEditModalOpen) {
                            currentUserRole = memberData.filter(
                                member => member.user_id == isRoleEditModalOpen
                            )[0].user_role;
                        }

                        return (
                            <div className='tab_container'>
                                <div className="name_info">
                                    <div className="user_picture_container">
                                        <img src={member.profile_picture} className='user_picture' />
                                    </div>
                                    <p className="Admin-name">
                                        {member.name}
                                    </p>
                                </div>

                                {RoleTag(member.user_role, member.accepted_invitation)}

                                {
                                    (currentUserData?.user_role ?? "MEMBER") == "OWNER" ? (
                                        <div className='memberActions'>
                                            <IconButton
                                                sx={{
                                                    marginRight: "5%",
                                                    backgroundColor: "#7020ff",
                                                    padding: "3%",
                                                    borderRadius: 2
                                                }}
                                                onClick={() => {
                                                    setIsRoleEditModalOpen(member.user_id)
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton
                                                sx={{
                                                    marginRight: "5%",
                                                    backgroundColor: "#7020ff",
                                                    padding: "3%",
                                                    borderRadius: 2
                                                }}
                                                onClick={() => removeAndSetOrganisationMember(organisationData.id, member.user_id)}
                                            >
                                                <GroupRemoveIcon />
                                            </IconButton>
                                        </div>
                                    ) : null
                                }


                                <EditRole open={isRoleEditModalOpen} handleClose={() => setIsRoleEditModalOpen(null)} role={currentUserRole} updateRole={(role) => updateAndSetUserRole(isRoleEditModalOpen, role)} />
                            </div>
                        )
                    })
                }
            </div>


            <div className='bottom-action-container'>
                {(currentUserData?.user_role ?? "MEMBER") == "OWNER" ? (
                    <Button
                        sx={{
                            backgroundColor: "#7020ff",
                            color: "#ffffff",
                            borderRadius: "16px 0px 16px 0px",
                            padding: "0% 1%",
                            minWidth: "18vw",
                        }}
                        onClick={() => setIsAddMemberModalOpen(true)}
                    >
                        <PersonAddIcon />
                        <p style={{
                            paddingLeft: "2%",
                            fontSize: "16px",
                            fontWeight: 600
                        }}>ADD MEMBER</p>
                    </Button>
                ) : null}
                {
                    memberPage == 0 ? null : (
                        <div className="nextPageContainer">
                            <IconButton
                                onClick={() => setMemberPage(page => page - 1)}
                            >
                                <NavigateBeforeIcon />
                            </IconButton>

                            Previous page
                        </div>
                    )
                }
                {
                    memberPage == totalMemberPages ? null : (
                        <div className="nextPageContainer">
                            Next page
                            <IconButton
                                onClick={() => setMemberPage(page => page + 1)}
                            >
                                <NavigateNextIcon />
                            </IconButton>
                        </div>
                    )
                }
            </div>

            <AddMember open={isAddMemberModalOpen} handleClose={() => setIsAddMemberModalOpen(false)} invitedMembers={invitedMembers} setInvitedMembers={setInvitedMembers} invitedMembersTextField={invitedMembersTextField} setInvitedMembersTextField={setInvitedMembersTextField} inviteMembers={inviteAndSetMembers} />
        
            {/* {(currentUserData?.user_role ?? "MEMBER") == "OWNER" ? (
                <Card sx={{ background: "#222222", maxWidth: "100%", borderRadius: "32px", margin: "5%" }}>
                    <CardContent id="usage" sx={{ padding: "10% 5%" }}>
                        <div className='usageRowContainer'>
                            <div className='profileActionPart' style={{ color: "#888888" }}>
                                <Typography variant="h4" sx={{ fontSize: 24, lineHeight: 1.2, marginBottom: "1%", fontWeight: "medium" }}>Usage</Typography>
                                <Typography variant="h5" sx={{ fontSize: 18, lineHeight: 1.2, paddingRight: "45%" }}>Here you can see the pricing and usage history.</Typography>
                            </div>
                            <div className='profileActionPart'>
                                <StackedBarChart data={organisationUsage} measureType={measureType} />
                            </div>
                        </div>
                        <UsageTable userUsage={organisationUsage} measureType={measureType} />
                    </CardContent>
                </Card>
            ): null} */}
            
        </Drawer>
    )
}